

export const flightModeStyle = {
  input: {
    border: '1px solid rgb(243, 243, 243)',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
  }
}
